var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 5.36C11.015 5.36 6.32 10.12 6.32 16h-.001c-.001 5.88 4.695 10.64 10.479 10.64 3.971 0 7.432-2.243 9.21-5.561a1.65 1.65 0 0 1 2.251-.677 1.69 1.69 0 0 1 .669 2.278c-2.336 4.355-6.89 7.32-12.13 7.32C9.173 30 3 23.728 3 16S9.174 2 16.8 2c5.24 0 9.794 2.964 12.129 7.319a1.69 1.69 0 0 1-.669 2.276 1.65 1.65 0 0 1-2.25-.675c-1.778-3.317-5.239-5.56-9.21-5.56zm2.307 9.987c.143-.323.216-.673.216-1.027 0-1.392-1.115-2.52-2.49-2.52s-2.49 1.128-2.49 2.52a2.527 2.527 0 0 0 .83 1.878V20.2h3.32v-4.002c.262-.237.47-.527.614-.85z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/CVC.555921c81235e9012a4633418e9c65bc.svg";
export { ForwardRef as ReactComponent };